import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { FilesManagerComponent } from '../../../../components/services/files-manager/files-manager.component';

@Component({
    selector: 'app-folder-documents-page',
    templateUrl: './folder-documents-page.component.html',
    styleUrl: './folder-documents-page.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FilesManagerComponent,
    ],
})
export class FolderDocumentsPageComponent extends SubscriptionComponent {

    private readonly route = inject(ActivatedRoute);

    protected folderId: number = 0;

    constructor() {
        super();
        this.subs.push(
            this.route.params.subscribe((params) => {
                this.folderId = Number(params.folderId || 0);
            }),
        );
    }

}
